import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalSize,
  ButtonAppearance,
  ModalClose,
  ModalFooter,
  theme,
} from '@bechtel/gds';
import { DeactivateConfirmModalProps } from './types';
import { DrawerFooterButtonStyled } from '@bechtel/client-common';
import { map, join } from 'lodash';
import { Trans, Plural, plural } from '@lingui/macro';

const DeactivateConfirmModal: FC<DeactivateConfirmModalProps> = ({ modules, onCancel, onConfirm }) => {
  const moduleCount = modules.length;
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="qty-config-error" style={{ width: '552px', height: '431px' }}>
      <ModalHeader title={plural(moduleCount, { one: 'Deactivate Module', other: 'Deactivate Modules' })}>
        <ModalClose onClick={onCancel}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box
          p={{ sm: '500' }}
          flexDirection={{ sm: 'column' }}
          alignItems={{ sm: 'center' }}
          justifyContent={{ sm: 'center' }}
        >
          <Box mx={{ sm: '550' }} mb={{ sm: '500' }}>
            <Text
              weight="600"
              size="500"
              family="graphik"
              color="grey.1000"
              style={{ lineHeight: `${theme.spacings[550]}`, textAlign: 'center' }}
            >
              <Plural
                value={moduleCount}
                one={`Are you sure you want to deactivate the ${join(map(modules, 'name'), ', ')} module?`}
                other={`Are you sure you want to deactivate the ${join(map(modules, 'name'), ', ')} modules?`}
              />
            </Text>
          </Box>
          <Box mx={{ sm: '550' }}>
            <Text
              size="400"
              family="graphik"
              color="grey.1000"
              style={{ lineHeight: `${theme.spacings[550]}`, textAlign: 'center' }}
            >
              <Plural
                value={moduleCount}
                one={`You're about to remove the entire module. Once it is deactivated, nobody will be able to access it.`}
                other={`You're about to remove the entire modules. Once these are deactivated, nobody will be able to access it.`}
              />
            </Text>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
              <Box px={{ sm: '500' }}>
                <Trans>Cancel</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
          <Box>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onConfirm}>
              <Box px={{ sm: '500' }}>
                <Trans>Confirm</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default DeactivateConfirmModal;
